import React, { useCallback } from 'react';
import { MD, SM } from '@zendeskgarden/react-typography';
import Flex from 'styled-flex-component';
import { Grid, Row, Col } from '@zendeskgarden/react-grid';
import { map, get, size, replace, includes } from 'lodash';
import DocumentDownload from 'components/DocumentDownload/DocumentDownload';
import { ProductsSectionHeader } from 'routes/Products/Products.styles';
import { PropTypes } from 'prop-types';
import AlloyComposition from 'components/AlloyComposition/AlloyComposition';
import { variables } from 'theme/variables';
import { productNominalDetailsShape } from '../../../../propTypesObjects';
import { webRefactorSwitch } from '../../../../utility/environment';
import { AlloyDetails } from './ProductsAlloyDetails.styles';

const { color_white: colorWhite } = variables;

function ProductsAlloyDetails({ productDetails, listingsRefactor }) {
  const {
    name,
    description,
    corrosion_resistance_name: corrosionResistanceName,
    metallurgy_group_name: metallurgyGroupName,
    files,
  } = productDetails?.metallurgy || {};
  const lotSummary = get(productDetails?.result, 'lot_summary');

  const renderAlloyCompositionTitle = useCallback(
    () => (
      <MD paddingBottomLg as="h3" bold>
        Elemental Composition
      </MD>
    ),
    []
  );

  return (
    <AlloyDetails listingsRefactor={listingsRefactor && webRefactorSwitch}>
      <Grid>
        <Row>
          <Col>
            {lotSummary && !listingsRefactor && (
              <ProductsSectionHeader tag="h2" paddingBottomMd scaled bold>
                Alloy Details
              </ProductsSectionHeader>
            )}
          </Col>
        </Row>

        <Row className="alloyDataRow">
          <Col className="alloyDataCol" size="auto">
            <MD paddingBottomSm as="h3" bold>
              Alloy
            </MD>
            <MD
              paddingBottomSm
              as="h3"
              style={{ fontWeight: '500', fontSize: '1rem' }}
            >
              {name || '--'}
            </MD>
          </Col>
          <Col className="alloyDataCol" size="auto">
            <MD paddingBottomSm as="h3" bold>
              Family
            </MD>
            <MD
              paddingBottomSm
              as="h3"
              style={{ fontWeight: '500', fontSize: '1rem' }}
            >
              {metallurgyGroupName || '--'}
            </MD>
          </Col>
          <Col className="alloyDataCol" size="auto">
            <MD paddingBottomSm as="h3" bold>
              Corrosion Resistance Level
            </MD>
            <MD
              paddingBottomSm
              as="h3"
              style={{ fontWeight: '500', fontSize: '1rem' }}
            >
              {corrosionResistanceName || '--'}
            </MD>
          </Col>
          {listingsRefactor && webRefactorSwitch && size(files) > 0 && (
            <Col className="lastAlloyDataCol" size="auto">
              {map(files, (file) => {
                const fileName = replace(
                  file.original_file_name,
                  '.pdf',
                  includes(file.original_file_name, 'Datasheet')
                    ? ''
                    : ' Datasheet'
                );
                const fileToSend = {
                  file: file?.file,
                  fileId: file?.id,
                  type: file?.type,
                  title: fileName,
                };
                return (
                  <a
                    key={file.id}
                    href={file.file}
                    download
                    aria-label="Download"
                  >
                    <DocumentDownload
                      documentItem={fileToSend}
                      style={{
                        backgroundColor: colorWhite,
                        borderRadius: '10px',
                      }}
                    />
                  </a>
                );
              })}
            </Col>
          )}
        </Row>

        <Row>
          <Col
            size="auto"
            style={{
              marginBottom:
                get(files, 'length') ||
                productDetails?.metallurgy?.has_chemical_composition
                  ? '30px'
                  : '0px',
            }}
          >
            <MD paddingBottomSm as="h3" bold>
              Alloy Description
            </MD>
            <SM
              paddingBottomSm
              as="h3"
              style={{ fontWeight: '500', fontSize: '1rem' }}
            >
              {description || '--'}
            </SM>
          </Col>
        </Row>

        {productDetails?.metallurgy?.has_chemical_composition ? (
          <Row>
            <Col className="elemCol" size="12" xl="12">
              <div style={{ whiteSpace: 'nowrap' }}>
                <AlloyComposition
                  data={productDetails?.metallurgy}
                  legacy={!webRefactorSwitch}
                  renderTitle={renderAlloyCompositionTitle}
                />
              </div>
            </Col>
          </Row>
        ) : null}

        {get(files, 'length') && !listingsRefactor ? (
          <Row>
            <Col style={{ marginTop: '20px' }}>
              <Flex wrap="wrap">
                {map(files, (f, i) => {
                  const title = get(f, 'original_file_name');
                  const fileId = get(f, 'id');
                  const type = 'Document';
                  return (
                    <div
                      style={{
                        maxWidth: '350px',
                        minWidth: '250px',
                        padding: '5px 12px',
                        marginLeft: '-12px',
                      }}
                      key={i}
                    >
                      <DocumentDownload
                        disableDelete
                        documentItem={{ title, type, fileId }}
                        legacy
                      />
                    </div>
                  );
                })}
              </Flex>
            </Col>
          </Row>
        ) : null}
      </Grid>
    </AlloyDetails>
  );
}

ProductsAlloyDetails.propTypes = {
  productDetails: productNominalDetailsShape,
  listingsRefactor: PropTypes.bool,
};

export default ProductsAlloyDetails;
